import Label from "src/components/atoms/labels/label";
import Banner from "src/components/molecules/banner/Banner";
import DropdownBox from "src/components/atoms/dropdown/dropdown-box";
import { ReactComponent as XIcon } from "../../../assets/svg/xIcon.svg";
import { ReactComponent as PlusIcon } from "../../../assets/svg/plusIcon.svg";
import InputBox from "src/components/atoms/v2/inputBox/inputBox";
import ButtonAddNew from "src/components/atoms/button-add-new/button-add-new";
import { ReactComponent as ChevronUpIcon } from "../../../assets/svg/chevron-up.svg";

const UserManagement = () => {
	return (
		<>
			<Banner label="User Management">
				<div className="flex flex-col items-start justify-center gap-2 w-full">
					<Label variant={"header"} text="Users"></Label>
					<Label
						variant={"text_md"}
						text=" If the current user has permission to manage users"
					></Label>
				</div>
				<div className="mt-6 flex items-center justify-end gap-4 w-full">
					<ButtonAddNew
						text="Invite new user"
						onClick={function (): void {
							throw new Error("Function not implemented.");
						}}
					></ButtonAddNew>
					<ButtonAddNew
						text="Create new role"
						onClick={function (): void {
							throw new Error("Function not implemented.");
						}}
					></ButtonAddNew>
				</div>
				<div className="mt-6 flex flex-col items-start justify-center gap-2 w-full">
					<InputBox
						label={"Filter user"}
						type={"text"}
						onChange={function (value: string): void {
							console.log(value);
						}}
					></InputBox>
				</div>
				<div className="mt-6 flex flex-col items-center justify-center gap-1 w-full">
					<div className="bg-gradient-to-r from-gray-100 to-gray-300 flex items-center justify-start gap-2 p-2 py-4 w-full pe-4">
						<div className="flex items-center justify-stretch w-full gap-2">
							<div id="header" className="">
								<Label
									variant={"subheader"}
									text="Krishnakant Mahamuni"
								></Label>
							</div>
							<Label variant={"text_md"} text="-"></Label>
							<div id="header" className="">
								<Label
									variant={"text_md"}
									text="krishnakant.mahamuni@theexpertstack.com"
								></Label>
							</div>
						</div>
						<ChevronUpIcon></ChevronUpIcon>
					</div>
					<div className="flex flex-col items-center justify-start gap-1 w-full ps-12">
						<div className="bg-gray-100 flex items-center justify-start gap-4 w-full p-2">
							<div className="w-1/2">
								<Label
									variant={"text_md"}
									text="Expertstack"
								></Label>
							</div>
							<div className="w-1/2">
								<div className="flex items-center justify-center gap-2 w-full">
									<div className="w-full">
										<DropdownBox
											defaultText={"Please select"}
											options={[
												{
													label: "Admin",
													value: "Admin",
												},
												{
													label: "Admin",
													value: "Admin",
												},
												{
													label: "Admin",
													value: "Admin",
												},
											]}
											onSelected={function (
												selectedOption
											): void {
												console.log(
													selectedOption.label
												);
											}}
										></DropdownBox>
									</div>
									<div className="">
										<XIcon className="w-6 h-6 text-red-600"></XIcon>
									</div>
								</div>
							</div>
						</div>
						<div className="bg-gray-100 flex items-center justify-start gap-4 w-full p-2">
							<div className="w-1/2">
								<Label variant={"text_md"} text="Tonik"></Label>
							</div>
							<div className="w-1/2">
								<div className="flex items-center justify-center gap-2 w-full">
									<div className="w-full">
										<DropdownBox
											defaultText={"Please select"}
											options={[
												{
													label: "Admin",
													value: "Admin",
												},
												{
													label: "Admin",
													value: "Admin",
												},
												{
													label: "Admin",
													value: "Admin",
												},
											]}
											onSelected={function (
												selectedOption
											): void {
												console.log(
													selectedOption.label
												);
											}}
										></DropdownBox>
									</div>
									<div className="">
										<XIcon className="w-6 h-6 text-red-600"></XIcon>
									</div>
								</div>
							</div>
						</div>
						<div className="bg-gray-100 flex items-center justify-start gap-4 w-full p-2">
							<div className="w-1/2">
								<Label
									variant={"text_md"}
									text="Customer science group"
								></Label>
							</div>
							<div className="w-1/2">
								<div className="flex items-center justify-center gap-2 w-full">
									<div className="w-full">
										<DropdownBox
											defaultText={"Please select"}
											options={[
												{
													label: "Admin",
													value: "Admin",
												},
												{
													label: "Admin",
													value: "Admin",
												},
												{
													label: "Admin",
													value: "Admin",
												},
											]}
											onSelected={function (
												selectedOption
											): void {
												console.log(
													selectedOption.label
												);
											}}
										></DropdownBox>
									</div>
									<div className="">
										<XIcon className="w-6 h-6 text-red-600"></XIcon>
									</div>
								</div>
							</div>
						</div>
						<div className="bg-gray-100 flex items-center justify-start gap-4 w-full p-2">
							<div className="w-1/2">
								<Label
									variant={"text_md"}
									text="ABN Bank"
								></Label>
							</div>
							<div className="w-1/2">
								<div className="flex items-center justify-center gap-2 w-full">
									<div className="w-full">
										<DropdownBox
											defaultText={"Please select"}
											options={[
												{
													label: "Admin",
													value: "Admin",
												},
												{
													label: "Admin",
													value: "Admin",
												},
												{
													label: "Admin",
													value: "Admin",
												},
											]}
											onSelected={function (
												selectedOption
											): void {
												console.log(
													selectedOption.label
												);
											}}
										></DropdownBox>
									</div>
									<div className="">
										<XIcon className="w-6 h-6 text-red-600"></XIcon>
									</div>
								</div>
							</div>
						</div>
						<div className="bg-sky-200 flex items-center justify-start gap-4 w-full p-2">
							<div className="w-1/2">
								<DropdownBox
									defaultText={"Please select"}
									options={[
										{
											label: "Expertstack",
											value: "Expertstack",
										},
										{
											label: "OG",
											value: "OG",
										},
										{
											label: "Microsoft",
											value: "Microsoft",
										},
									]}
									onSelected={function (
										selectedOption
									): void {
										console.log(selectedOption.label);
									}}
								></DropdownBox>
							</div>
							<div className="w-1/2">
								<div className="flex items-center justify-center gap-2 w-full">
									<div className="w-full">
										<DropdownBox
											defaultText={"Please select"}
											options={[
												{
													label: "Admin",
													value: "Admin",
												},
												{
													label: "Admin",
													value: "Admin",
												},
												{
													label: "Admin",
													value: "Admin",
												},
											]}
											onSelected={function (
												selectedOption
											): void {
												console.log(
													selectedOption.label
												);
											}}
										></DropdownBox>
									</div>
									<div className="">
										<XIcon className="w-6 h-6 text-red-600"></XIcon>
									</div>
								</div>
							</div>
						</div>
						<div className="flex items-center justify-end gap-4 w-full p-2">
							<PlusIcon className="w-6 h-6 text-sky-600"></PlusIcon>
						</div>
					</div>
					<div className="bg-gradient-to-r from-gray-100 to-gray-300 flex items-center justify-start gap-4 p-2 py-4 w-full pe-4">
						<div className="flex items-center justify-stretch w-full gap-2">
							<div id="header" className="">
								<Label
									variant={"subheader"}
									text="Sampada thorat"
								></Label>
							</div>
							<Label variant={"text_md"} text="-"></Label>
							<div id="header" className="">
								<Label
									variant={"text_md"}
									text="sampada.thorat@theexpertstack.com"
								></Label>
							</div>
						</div>
						<ChevronUpIcon></ChevronUpIcon>
					</div>
					<div className="flex flex-col items-center justify-start gap-1 w-full ps-12">
						<div className="bg-sky-200 flex items-center justify-start gap-4 w-full p-2">
							<div className="w-1/2">
								<DropdownBox
									defaultText={"Please select"}
									options={[
										{
											label: "Expertstack",
											value: "Expertstack",
										},
										{
											label: "OG",
											value: "OG",
										},
										{
											label: "Microsoft",
											value: "Microsoft",
										},
									]}
									onSelected={function (
										selectedOption
									): void {
										console.log(selectedOption.label);
									}}
								></DropdownBox>
							</div>
							<div className="w-1/2">
								<div className="flex items-center justify-center gap-2 w-full">
									<div className="w-full">
										<DropdownBox
											defaultText={"Please select"}
											options={[
												{
													label: "Admin",
													value: "Admin",
												},
												{
													label: "Admin",
													value: "Admin",
												},
												{
													label: "Admin",
													value: "Admin",
												},
											]}
											onSelected={function (
												selectedOption
											): void {
												console.log(
													selectedOption.label
												);
											}}
										></DropdownBox>
									</div>
									<div className="">
										<XIcon className="w-6 h-6 text-red-600"></XIcon>
									</div>
								</div>
							</div>
						</div>
						<div className="flex items-center justify-end gap-4 w-full p-2">
							<PlusIcon className="w-6 h-6 text-sky-600"></PlusIcon>
						</div>
					</div>
				</div>
			</Banner>
		</>
	);
};

export default UserManagement;
